import { 
  put, 
  fork, 
  take,
  takeEvery, 
} from 'redux-saga/effects'; 
import { 
  showMessage,
  deleteSettings,
  loadSettings,
  saveSettings,
  API_DELETE_SUCCESS,
  API_UPDATE_SUCCESS,
} from 'vx-commons/lib/actions';
import { 
  SAVE_DASHBOARD,
  RESET_DASHBOARD 
} from './actions';

export function* resetDashboard(action) {
  console.log('resetDashboard', action);
  yield put(deleteSettings(action.name, action.id));
  const ret = yield take([API_DELETE_SUCCESS]);
  console.log('ret', ret);
  yield put(loadSettings(action.name));
  yield put(showMessage('Dashboard has been restored to defaults'));
}

export function* saveDashboard(action) {
  console.log('saveDashboard', action);
  yield put(saveSettings(action.name, action.settings));
  const ret = yield take([API_UPDATE_SUCCESS]);
  console.log('ret', ret);
  yield put(loadSettings(action.name));
  yield put(showMessage('Dashboard has been saved'));
}

export function* saga() {
  // Fork watcher so we can continue execution
  yield* [
    fork(takeEvery, RESET_DASHBOARD, resetDashboard),
    fork(takeEvery, SAVE_DASHBOARD, saveDashboard),
  ];
}

// Bootstrap sagas
export default saga;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/sagas.js